import * as React from "react";
import { FormSection } from "./components/FormSection";
import { ComplianceSection } from "./components/ComplianceSection";
import Heading from "../../components/Heading";
import InputField from "../../components/Forms/InputField";
import { TextArea } from "../../components/Forms/TextArea";
import { ActionButton } from "../../components/Forms/ActionButton";
import ImageInput from "../../components/Forms/ImageInput";
import { getCompanyDetails, updateCompany } from "../../api/users";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useLocation } from "react-router-dom";

const CompanyEdit = () => {

    const { state } = useLocation();
    
    const [formData, setFormData] = React.useState([
        { label: 'Company Name', placeholder: 'Enter Company Name', name: 'companyName', value: '' },
        { label: 'Industry/Sector', placeholder: 'Enter Industry/Sector', name: 'industryOrSector', value: '' },
        { label: 'Short Description Of Company’s Services/Products', placeholder: 'Write A Short Description Of Company’s Services/Products', name: 'description', value: '' },
        { label: 'Branch Address', placeholder: 'Enter Branch Address', name: 'branchAddress', value: '' },
        { label: 'Phone Number', placeholder: 'Enter Phone Number', name: 'phone', value: '' },
        { label: 'Email', placeholder: 'Enter Email', name: 'email', value: '' },
        { label: 'Headquarter Address', placeholder: 'Enter Headquarter Address', name: 'headquarterAddress', value: '' },
        { label: 'Website Url', placeholder: 'Enter Website Url', name: 'websiteUrl', value: '' },
        { label: 'Registration Number', placeholder: 'Enter Registration Number', name: 'registrationNumber', value: '' },
        { label: 'Tax Identification Number', placeholder: 'Enter Tax Identification Number', name: 'taxIdentificationNumber', value: '' },
    ]);

    const [socialFields, setSocialFields] = React.useState([
        { label: 'LinkedIn Account Link', placeholder: 'Enter LinkedIn Account Link', name: 'linkedIn', value: '' },
        { label: 'Instagram Account Link', placeholder: 'Enter Instagram Account Link', name: 'instagram', value: '' },
        { label: 'Facebook Account Link', placeholder: 'Enter Facebook Account Link', name: 'facebook', value: '' },
        { label: 'Twitter Account Link', placeholder: 'Enter Twitter Account Link', name: 'twitter', value: '' },
        { label: 'YouTube Account Link', placeholder: 'Enter YouTube Account Link', name: 'youtube', value: '' },
        { label: 'Website Link', placeholder: 'Enter Website Link', name: 'website', value: '' }
    ]);

    const [accountFields, setAccountFields] = React.useState([
        { label: 'Username', placeholder: 'Enter Username', name: 'username', value: '' },
        { label: 'Password', placeholder: 'Enter Password', name: 'password', value: '', type: 'password' },
        { label: 'Display Name', placeholder: 'Enter Display Name', name: 'displayName', value: '' },
    ]);

    const [pocFields, setPocFields] = React.useState([
        { label: 'Name', placeholder: 'Enter POC Name', name: 'pocName', value: '' },
        { label: 'Designation', placeholder: 'Enter POC Designation', name: 'pocDesignation', value: '' },
        { label: 'Department', placeholder: 'Enter POC Department', name: 'pocDepartment', value: '' },
        { label: 'Phone', placeholder: 'Enter POC Phone', name: 'pocPhone', value: '' },
        { label: 'Mobile Number', placeholder: 'Enter POC Mobile', name: 'pocMobile', value: '' },
        { label: 'Email Address', placeholder: 'Enter POC Email', name: 'pocEmail', value: '' },
    ]);

    const [partnerFields, setPartnerFields] = React.useState([
        { label: 'Type Of Partnership', placeholder: 'Select Type Of Partnership', name: 'typeOfPartnership', value: '', type: 'select', data: [
            { value: 'One Time', placeholder: 'One Time' },
            { value: 'Regular', placeholder: 'Regular' },
        ] },
        { label: 'Partnership Start Date', placeholder: 'Select Partnership Start Date', name: 'partnershipStartDate', value: '', type: 'date' },
        { label: 'Category Of Challenge Preferred', placeholder: 'Select Category Of Challenge Preferred', name: 'categoryOfChallengePreferred', value: '', type: 'select', data: [
            { value: 'Travel', placeholder: 'Travel' },
            { value: 'Electricity', placeholder: 'Electricity' },
        ] },
        { label: 'Rewards Offered', placeholder: 'Select Rewards Offered', name: 'rewardsOffered', value: '', type: 'select', data: [
            { value: 'Coupon', placeholder: 'Coupon' },
            { value: 'Product', placeholder: 'Product' },
        ] },
        { label: 'Number Of Products On Offer', placeholder: 'Select Number Of Products On Offer', name: 'numberOfProductsOnOffer', value: '', type: 'number' },
        { label: 'Type Of Products On Offer', placeholder: 'Select Type Of Products On Offer', name: 'typeOfProductsOnOffer', value: '', type: 'test' },
        { label: 'Price Range Of Products On Offer', placeholder: 'Select Price Range Of Products On Offer', name: 'priceRangeOfProductsOnOffer', value: '', type: 'text' },
        { label: 'Details Of Donation Preference', placeholder: 'Enter Details Of Donation Preference', name: 'detailsOfDonationPreference', value: ''},
        { label: 'Details Of Specific Projects', placeholder: 'Enter Details Of Specific Projects', name: 'detailsOfSpecificProjects', value: ''},
        { label: 'Details Of CSR Goals', placeholder: 'Enter Details Of CSR Goals', name: 'detailsOfCSRGoals', value: '' },
    ]);

    const [targetUserFields, setTargetUserFields] = React.useState([
        { label: 'Brand Awareness', placeholder: 'Enter Brand Awareness', name: 'brandAwareness', value: '' },
        { label: 'Lead Generation', placeholder: 'Enter Lead Generation', name: 'leadGeneration', value: '' },
        { label: 'CSR', placeholder: 'Enter CSR', name: 'csr', value: '' },
        { label: 'ESG', placeholder: 'Enter ESG', name: 'esg', value: '' },
    ]);

    const [financialFields, setFinancialFields] = React.useState([
        { label: 'Bank Account Details', placeholder: 'Enter Bank Account Details', name: 'bankAccountDetails', value: '' },
        { label: 'Payment Terms', placeholder: 'Enter Payment Terms', name: 'paymentTerms', value: '' },
        { label: 'Agreement On Revenue Share Or Commission Rates', placeholder: 'Enter Agreement On Revenue Share Or Commission Rates', name: 'agreementOnRevenueShareOrCommissionRates', value: '' },
    ]);

    const [impactFields, setImpactFields] = React.useState([
        { label: 'Metrics Data Points', placeholder: 'Enter Metrics Data Points', name: 'metricsDataPoints', value: '' },
        { label: 'Reporting Frequency', placeholder: 'Enter Reporting Frequency', name: 'reportingFrequency', value: '', type: 'select', data: [
            { value: 'Daily', placeholder: 'Daily' },
            { value: 'Weekly', placeholder: 'Weekly' },
            { value: 'Monthly', placeholder: 'Monthly' },
            { value: 'Quarterly', placeholder: 'Quarterly' },
            { value: 'Yearly', placeholder: 'Yearly' },
        ] },
        { label: 'A Short Paragraph On The Sponsor Company', placeholder: 'Write A Short Paragraph On The Sponsor Company', name: 'aShortParagraphOnTheSponsorCompany', value: '' },
        { label: 'Remarks/Notes', placeholder: 'Enter Remarks/Notes', name: 'remarksOrNotes', value: '' },
        { label: 'Attachments', placeholder: 'Enter Attachments', name: 'attachments', value: [] },
    ]);
    
    const [image, setImage] = React.useState(null);

    const handleChange = (index, newValue) => {
        setFormData(prevFields =>
            prevFields.map((field, i) =>
                i === index ? { ...field, value: newValue } : field
            )
        );
    };
    const handleSocialChange = (index, newValue) => {
        setSocialFields(prevFields =>
            prevFields.map((field, i) =>
                i === index ? { ...field, value: newValue } : field
            )
        );
    };
    const handleAccountChange = (index, newValue) => {
        setAccountFields(prevFields =>
            prevFields.map((field, i) =>
                i === index ? { ...field, value: newValue } : field
            )
        );
    };
    const handlePocChange = (index, newValue) => {
        setPocFields(prevFields =>
            prevFields.map((field, i) =>
                i === index ? { ...field, value: newValue } : field
            )
        );
    };
    const handlePartnerChange = (index, newValue) => {
        setPartnerFields(prevFields =>
            prevFields.map((field, i) =>
                i === index ? { ...field, value: newValue } : field
            )
        );
    };
    const handleTargetUserChange = (index, newValue) => {
        setTargetUserFields(prevFields =>
            prevFields.map((field, i) =>
                i === index ? { ...field, value: newValue } : field
            )
        );
    };
    const handleFinancialChange = (index, newValue) => {
        setFinancialFields(prevFields =>
            prevFields.map((field, i) =>
                i === index ? { ...field, value: newValue } : field
            )
        );
    };
    const handleImpactChange = (index, newValue) => {
        setImpactFields(prevFields =>
            prevFields.map((field, i) =>
                i === index ? { ...field, value: newValue } : field
            )
        );
    };

    // const validateForm = () => {
    //     const newErrors = {};
    //     if (!formData.companyName) newErrors.companyName = "Company name is required";
    //     if (!formData.email) newErrors.email = "Email is required";
    //     if (!formData.phoneNumber) newErrors.phoneNumber = "Phone number is required";

    //     return Object.keys(newErrors).length === 0;
    // };

    const handleSubmit = async (e) => {
        e.preventDefault();
        // if (!validateForm()) return;
        const data = {
            companyName: formData[0].value,
            industryOrSector: formData[1].value,
            description: formData[2].value,
            branchAddress: formData[3].value,
            phone: formData[4].value,
            email: formData[5].value,
            headquarterAddress: formData[6].value,
            websiteUrl: formData[7].value,
            registrationNumber: formData[8].value,
            taxIdentificationNumber: formData[9].value,
            linkedIn: socialFields[0].value,
            instagram: socialFields[1].value,
            facebook: socialFields[2].value,
            twitter: socialFields[3].value,
            youtube: socialFields[4].value,
            website: socialFields[5].value,
            username: accountFields[0].value,
            password: accountFields[1].value,
            displayName: accountFields[2].value,
            pocName: pocFields[0].value,
            pocDesignation: pocFields[1].value,
            pocDepartment: pocFields[2].value,
            pocPhone: pocFields[3].value,
            pocMobile: pocFields[4].value,
            pocEmail: pocFields[5].value,
            typeOfPartnership: partnerFields[0].value,
            partnershipStartDate: partnerFields[1].value,
            categoryOfChallengePreferred: partnerFields[2].value,
            rewardsOffered: partnerFields[3].value,
            numberOfProductsOnOffer: partnerFields[4].value,
            typeOfProductsOnOffer: partnerFields[5].value,
            priceRangeOfProductsOnOffer: partnerFields[6].value,
            detailsOfDonationPreference: partnerFields[7].value,
            detailsOfSpecificProjects: partnerFields[8].value,
            detailsOfCSRGoals: partnerFields[9].value,
            brandAwareness: targetUserFields[0].value,
            leadGeneration: targetUserFields[1].value,
            csr: targetUserFields[2].value,
            esg: targetUserFields[3].value,
            bankAccountDetails: financialFields[0].value,
            paymentTerms: financialFields[1].value,
            agreementOnRevenueShareOrCommissionRates: financialFields[2].value,
            metricsDataPoints: impactFields[0].value,
            reportingFrequency: impactFields[1].value,
            aShortParagraphOnTheSponsorCompany: impactFields[2].value,
            remarksOrNotes: impactFields[3].value,
            isImagePresent: image.type ? true : false,
        };
        
        updateCompany(state._id, data, image, toast);
    };

    React.useEffect(() => {
        getCompanyDetails(state._id, formData, setFormData, socialFields, setSocialFields, accountFields, setAccountFields, pocFields, setPocFields, partnerFields, setPartnerFields, targetUserFields, setTargetUserFields, financialFields, setFinancialFields, impactFields, setImpactFields, setImage, toast);
        // eslint-disable-next-line
    }, []);
    
    return (
        <form className="flex flex-col m-5" noValidate>
            <Heading
                text={"Company Creation Form"}
            />

            <FormSection title="Company Details">
                <div className="flex flex-wrap gap-6 items-start w-full max-md:max-w-full">
                    <div className="flex flex-col grow shrink text-sm min-w-[240px] w-[844px] max-md:max-w-full">
                        <div className="flex flex-wrap gap-3 items-center">
                            <InputField
                                label={formData[0].label}
                                name={formData[0].name}
                                value={formData[0].value}
                                placeholder={formData[0].placeholder}
                                type={formData[0].type}
                                required={formData[0].required}
                                onChange={e => handleChange(0, e.target.value)}
                            />
                            <InputField
                                label={formData[1].label}
                                name={formData[1].name}
                                value={formData[1].value}
                                placeholder={formData[1].placeholder}
                                type={formData[1].type}
                                required={formData[1].required}
                                onChange={e => handleChange(1, e.target.value)}
                            />
                        </div>
                        <TextArea
                            label={formData[2].label}
                            placeholder={formData[2].placeholder}
                            minHeight="180px"
                            name={formData[2].name}
                            type={formData[2].type}
                            value={formData[2].value}
                            onChange={e => handleChange(2, e.target.value)}
                        />
                    </div>
                    <div className="flex flex-col grow shrink w-36 min-h-[250px]">
                        <ImageInput
                            image={image}
                            setImage={setImage}
                            text={'Company Logo'}
                        />
                    </div>
                </div>
                <InputField
                    label={formData[3].label}
                    name={formData[3].name}
                    value={formData[3].value}
                    placeholder={formData[3].placeholder}
                    type={formData[3].type}
                    required={formData[3].required}
                    onChange={e => handleChange(3, e.target.value)}
                />
                <div className="flex flex-wrap gap-3">
                    <InputField
                        label={formData[4].label}
                        name={formData[4].name}
                        value={formData[4].value}
                        placeholder={formData[4].placeholder}
                        type={formData[4].type}
                        required={formData[4].required}
                        onChange={e => handleChange(4, e.target.value)}
                    />
                    <InputField
                        label={formData[5].label}
                        name={formData[5].name}
                        value={formData[5].value}
                        placeholder={formData[5].placeholder}
                        type={formData[5].type}
                        required={formData[5].required}
                        onChange={e => handleChange(5, e.target.value)}
                    />
                </div>
                <InputField
                    label={formData[6].label}
                    name={formData[6].name}
                    value={formData[6].value}
                    placeholder={formData[6].placeholder}
                    type={formData[6].type}
                    required={formData[6].required}
                    onChange={e => handleChange(6, e.target.value)}
                />
                <div className="flex flex-wrap gap-3">
                    <InputField
                        label={formData[7].label}
                        name={formData[7].name}
                        value={formData[7].value}
                        placeholder={formData[7].placeholder}
                        type={formData[7].type}
                        required={formData[7].required}
                        onChange={e => handleChange(7, e.target.value)}
                    />
                    <InputField
                        label={formData[8].label}
                        name={formData[8].name}
                        value={formData[8].value}
                        placeholder={formData[8].placeholder}
                        type={formData[8].type}
                        required={formData[8].required}
                        onChange={e => handleChange(8, e.target.value)}
                    />
                    <InputField
                        label={formData[9].label}
                        name={formData[9].name}
                        value={formData[9].value}
                        placeholder={formData[9].placeholder}
                        type={formData[9].type}
                        required={formData[9].required}
                        onChange={e => handleChange(9, e.target.value)}
                    />
                </div>
            </FormSection>

            <FormSection title="Social Media Details">
                <div className="flex flex-wrap gap-3">
                    <InputField
                        label={socialFields[0].label}
                        name={socialFields[0].name}
                        value={socialFields[0].value}
                        placeholder={socialFields[0].placeholder}
                        type={socialFields[0].type}
                        required={socialFields[0].required}
                        onChange={e => handleSocialChange(0, e.target.value)}
                    />
                    <InputField
                        label={socialFields[1].label}
                        name={socialFields[1].name}
                        value={socialFields[1].value}
                        placeholder={socialFields[1].placeholder}
                        type={socialFields[1].type}
                        required={socialFields[1].required}
                        onChange={e => handleSocialChange(1, e.target.value)}
                    />
                </div>
                <div className="flex flex-wrap gap-3">
                    <InputField
                        label={socialFields[2].label}
                        name={socialFields[2].name}
                        value={socialFields[2].value}
                        placeholder={socialFields[2].placeholder}
                        type={socialFields[2].type}
                        required={socialFields[2].required}
                        onChange={e => handleSocialChange(2, e.target.value)}
                    />
                    <InputField
                        label={socialFields[3].label}
                        name={socialFields[3].name}
                        value={socialFields[3].value}
                        placeholder={socialFields[3].placeholder}
                        type={socialFields[3].type}
                        required={socialFields[3].required}
                        onChange={e => handleSocialChange(3, e.target.value)}
                    />
                </div>
                <div className="flex flex-wrap gap-3">
                    <InputField
                        label={socialFields[4].label}
                        name={socialFields[4].name}
                        value={socialFields[4].value}
                        placeholder={socialFields[4].placeholder}
                        type={socialFields[4].type}
                        required={socialFields[4].required}
                        onChange={e => handleSocialChange(4, e.target.value)}
                    />
                    <InputField
                        label={socialFields[5].label}
                        name={socialFields[5].name}
                        value={socialFields[5].value}
                        placeholder={socialFields[5].placeholder}
                        type={socialFields[5].type}
                        required={socialFields[5].required}
                        onChange={e => handleSocialChange(5, e.target.value)}
                    />
                </div>
            </FormSection>

            <FormSection title="Account Details">
                <div className="flex gap-3">
                    <InputField
                        label={accountFields[0].label}
                        name={accountFields[0].name}
                        value={accountFields[0].value}
                        placeholder={accountFields[0].placeholder}
                        type={accountFields[0].type}
                        required={accountFields[0].required}
                        onChange={e => handleAccountChange(0, e.target.value)}
                    />
                    <InputField
                        label={accountFields[1].label}
                        name={accountFields[1].name}
                        value={accountFields[1].value}
                        placeholder={accountFields[1].placeholder}
                        type={accountFields[1].type}
                        required={accountFields[1].required}
                        onChange={e => handleAccountChange(1, e.target.value)}
                        disabled={true}
                    />
                    <InputField
                        label={accountFields[2].label}
                        name={accountFields[2].name}
                        value={accountFields[2].value}
                        placeholder={accountFields[2].placeholder}
                        type={accountFields[2].type}
                        required={accountFields[2].required}
                        onChange={e => handleAccountChange(2, e.target.value)}
                    />
                </div>
            </FormSection>

            <FormSection title="Point Of Contact">
                <div className="flex gap-3">
                    <InputField
                        label={pocFields[0].label}
                        name={pocFields[0].name}
                        value={pocFields[0].value}
                        placeholder={pocFields[0].placeholder}
                        type={pocFields[0].type}
                        required={pocFields[0].required}
                        onChange={e => handlePocChange(0, e.target.value)}
                    />
                    <InputField
                        label={pocFields[1].label}
                        name={pocFields[1].name}
                        value={pocFields[1].value}
                        placeholder={pocFields[1].placeholder}
                        type={pocFields[1].type}
                        required={pocFields[1].required}
                        onChange={e => handlePocChange(1, e.target.value)}
                    />
                    <InputField
                        label={pocFields[2].label}
                        name={pocFields[2].name}
                        value={pocFields[2].value}
                        placeholder={pocFields[2].placeholder}
                        type={pocFields[2].type}
                        required={pocFields[2].required}
                        onChange={e => handlePocChange(2, e.target.value)}
                    />
                </div>
                <div className="flex gap-3">
                    <InputField
                        label={pocFields[3].label}
                        name={pocFields[3].name}
                        value={pocFields[3].value}
                        placeholder={pocFields[3].placeholder}
                        type={pocFields[3].type}
                        required={pocFields[3].required}
                        onChange={e => handlePocChange(3, e.target.value)}
                    />
                    <InputField
                        label={pocFields[4].label}
                        name={pocFields[4].name}
                        value={pocFields[4].value}
                        placeholder={pocFields[4].placeholder}
                        type={pocFields[4].type}
                        required={pocFields[4].required}
                        onChange={e => handlePocChange(4, e.target.value)}
                    />
                    <InputField
                        label={pocFields[5].label}
                        name={pocFields[5].name}
                        value={pocFields[5].value}
                        placeholder={pocFields[5].placeholder}
                        type={pocFields[5].type}
                        required={pocFields[5].required}
                        onChange={e => handlePocChange(5, e.target.value)}
                    />
                </div>
            </FormSection>

            <FormSection title="Partnership Details">
                <div className="flex gap-3">
                    <InputField
                        label={partnerFields[0].label}
                        name={partnerFields[0].name}
                        value={partnerFields[0].value}
                        placeholder={partnerFields[0].placeholder}
                        type={partnerFields[0].type}
                        required={partnerFields[0].required}
                        onChange={e => handlePartnerChange(0, e.target.value)}
                        data={partnerFields[0].data}
                    />
                    <InputField
                        label={partnerFields[1].label}
                        name={partnerFields[1].name}
                        value={partnerFields[1].value ? new Date(partnerFields[1].value).toISOString().split("T")[0] : ''}
                        placeholder={partnerFields[1].placeholder}
                        type={partnerFields[1].type}
                        required={partnerFields[1].required}
                        onChange={e => handlePartnerChange(1, e.target.value)}
                    />
                </div>
                <div className="flex gap-3">
                    <InputField
                        label={partnerFields[2].label}
                        name={partnerFields[2].name}
                        value={partnerFields[2].value}
                        placeholder={partnerFields[2].placeholder}
                        type={partnerFields[2].type}
                        required={partnerFields[2].required}
                        onChange={e => handlePartnerChange(2, e.target.value)}
                        data={partnerFields[2].data}
                    />
                    <InputField
                        label={partnerFields[3].label}
                        name={partnerFields[3].name}
                        value={partnerFields[3].value}
                        placeholder={partnerFields[3].placeholder}
                        type={partnerFields[3].type}
                        required={partnerFields[3].required}
                        onChange={e => handlePartnerChange(3, e.target.value)}
                        data={partnerFields[3].data}
                    />
                </div>
                <div className="flex gap-3">
                    <InputField
                        label={partnerFields[4].label}
                        name={partnerFields[4].name}
                        value={partnerFields[4].value}
                        placeholder={partnerFields[4].placeholder}
                        type={partnerFields[4].type}
                        required={partnerFields[4].required}
                        onChange={e => handlePartnerChange(4, e.target.value)}
                    />
                    <InputField
                        label={partnerFields[5].label}
                        name={partnerFields[5].name}
                        value={partnerFields[5].value}
                        placeholder={partnerFields[5].placeholder}
                        type={partnerFields[5].type}
                        required={partnerFields[5].required}
                        onChange={e => handlePartnerChange(5, e.target.value)}
                    />
                    <InputField
                        label={partnerFields[6].label}
                        name={partnerFields[6].name}
                        value={partnerFields[6].value}
                        placeholder={partnerFields[6].placeholder}
                        type={partnerFields[6].type}
                        required={partnerFields[6].required}
                        onChange={e => handlePartnerChange(6, e.target.value)}
                    />
                </div>
                <TextArea
                    label={partnerFields[7].label}
                    placeholder={partnerFields[7].placeholder}
                    minHeight="180px"
                    name={partnerFields[7].name}
                    type={partnerFields[7].type}
                    value={partnerFields[7].value}
                    onChange={e => handlePartnerChange(7, e.target.value)}
                />
                <TextArea
                    label={partnerFields[8].label}
                    placeholder={partnerFields[8].placeholder}
                    minHeight="180px"
                    name={partnerFields[8].name}
                    type={partnerFields[8].type}
                    value={partnerFields[8].value}
                    onChange={e => handlePartnerChange(8, e.target.value)}
                />
                <TextArea
                    label={partnerFields[9].label}
                    placeholder={partnerFields[9].placeholder}
                    minHeight="180px"
                    name={partnerFields[9].name}
                    type={partnerFields[9].type}
                    value={partnerFields[9].value}
                    onChange={e => handlePartnerChange(9, e.target.value)}
                />
            </FormSection>

            <FormSection title="Target User Age Group Partnership Objectives">
                <div className="flex gap-3">
                    <InputField
                        label={targetUserFields[0].label}
                        name={targetUserFields[0].name}
                        value={targetUserFields[0].value}
                        placeholder={targetUserFields[0].placeholder}
                        type={targetUserFields[0].type}
                        required={targetUserFields[0].required}
                        onChange={e => handleTargetUserChange(0, e.target.value)}
                    />
                    <InputField
                        label={targetUserFields[1].label}
                        name={targetUserFields[1].name}
                        value={targetUserFields[1].value}
                        placeholder={targetUserFields[1].placeholder}
                        type={targetUserFields[1].type}
                        required={targetUserFields[1].required}
                        onChange={e => handleTargetUserChange(1, e.target.value)}
                    />
                </div>
                <div className="flex gap-3">
                    <InputField
                        label={targetUserFields[2].label}
                        name={targetUserFields[2].name}
                        value={targetUserFields[2].value}
                        placeholder={targetUserFields[2].placeholder}
                        type={targetUserFields[2].type}
                        required={targetUserFields[2].required}
                        onChange={e => handleTargetUserChange(2, e.target.value)}
                    />
                    <InputField
                        label={targetUserFields[3].label}
                        name={targetUserFields[3].name}
                        value={targetUserFields[3].value}
                        placeholder={targetUserFields[3].placeholder}
                        type={targetUserFields[3].type}
                        required={targetUserFields[3].required}
                        onChange={e => handleTargetUserChange(3, e.target.value)}
                    />
                </div>
            </FormSection>

            <ComplianceSection />

            <FormSection title="Financial Details">
                <InputField
                    label={financialFields[0].label}
                    name={financialFields[0].name}
                    value={financialFields[0].value}
                    placeholder={financialFields[0].placeholder}
                    type={financialFields[0].type}
                    required={financialFields[0].required}
                    onChange={e => handleFinancialChange(0, e.target.value)}
                />
                <InputField
                    label={financialFields[1].label}
                    name={financialFields[1].name}
                    value={financialFields[1].value}
                    placeholder={financialFields[1].placeholder}
                    type={financialFields[1].type}
                    required={financialFields[1].required}
                    onChange={e => handleFinancialChange(1, e.target.value)}
                />
                <InputField
                    label={financialFields[2].label}
                    name={financialFields[2].name}
                    value={financialFields[2].value}
                    placeholder={financialFields[2].placeholder}
                    type={financialFields[2].type}
                    required={financialFields[2].required}
                    onChange={e => handleFinancialChange(2, e.target.value)}
                />
            </FormSection>

            <FormSection title="Impact & Reporting">
                <div className="flex flex-wrap gap-3">
                    <InputField
                        label={impactFields[0].label}
                        name={impactFields[0].name}
                        value={impactFields[0].value}
                        placeholder={impactFields[0].placeholder}
                        type={impactFields[0].type}
                        required={impactFields[0].required}
                        onChange={e => handleImpactChange(0, e.target.value)}
                    />
                    <InputField
                        label={impactFields[1].label}
                        name={impactFields[1].name}
                        value={impactFields[1].value}
                        placeholder={impactFields[1].placeholder}
                        type={impactFields[1].type}
                        required={impactFields[1].required}
                        onChange={e => handleImpactChange(1, e.target.value)}
                        data={impactFields[1].data}
                    />
                </div>
                <TextArea
                    label={impactFields[2].label}
                    placeholder={impactFields[2].placeholder}
                    minHeight="180px"
                    name={impactFields[2].name}
                    type={impactFields[2].type}
                    value={impactFields[2].value}
                    onChange={e => handleImpactChange(2, e.target.value)}
                />
                <TextArea
                    label={impactFields[3].label}
                    placeholder={impactFields[3].placeholder}
                    minHeight="180px"
                    name={impactFields[3].name}
                    type={impactFields[3].type}
                    value={impactFields[3].value}
                    onChange={e => handleImpactChange(3, e.target.value)}
                />
            </FormSection>

            {/* <ImpactReportingForm handleSubmit={handleSubmit} /> */}

            <div className="flex mt-5 justify-between">
                <ActionButton
                    variant={'reset'}
                    text={'Reset Form'}
                />
                <div className="flex gap-5">
                    <ActionButton
                        variant={'cancel'}
                        text={'Cancel'}
                    />
                    <ActionButton
                        variant={'submit'}
                        text={'Submit'}
                        handleSubmit={handleSubmit}
                    />
                </div>
            </div>

            <ToastContainer
                position = "top-right"
                autoClose={1000}
            />
        </form>
    );
}

export default CompanyEdit;